<template>
  <router-link :to="to" v-slot="{ href, navigate, isActive, isExactActive }" exact>
    <li :class="[isActive && 'active', isExactActive && 'exact-active']">
      <a :href="href" @click="navigate">{{label}}</a>
    </li>
  </router-link>
</template>

<script>
export default {
  name: 'NavItem',

  props: {
    to: {
      type: String,
      required: true,
    },

    label: {
      type: String,
      required: true,
    },
  },
};
</script>
